<template>
    <main>
        <template v-if="!hideHeader">
            <h2>{{ $t( 'dashboard.my_dashboard' ) }}</h2>
            <ReoTabBox
                :leftTabText="$t('dashboard.tabs.tab_cloud_service')"
                :rightTabText="$t('dashboard.tabs.tab_sim_service')"
                @tabChange="tabChange"
                :defaultTab="defaultTab"
            />
        </template>
        <KeepAlive>
            <dashboard  v-if="currentTab === 'cloud'"/>
            <SimList  v-if="currentTab === 'sim'"/>
        </KeepAlive>
    </main>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoTabBox from '@/components/ReoTabBox.vue';
import dashboard from './components/dashboard.vue';
import SimList from '@/components/SimList.vue';
import { productsManager } from '@/lib';
import { getQueryParam } from '@/common/js/utils';

export default Vue.extend({
    components: {
        ReoTabBox,
        dashboard,
        SimList
    },
    async created() {

        await productsManager.update({ lang: this.$i18n.locale });

    },
    data() {

        const tab = getQueryParam( this.$route, 'tab', 'cloud' )[0];

        return {
            currentTab: tab as 'sim' | 'cloud'
        };

    },
    computed: {

        defaultTab(): boolean {

            if ( this.currentTab === 'sim' ) {

                return false;

            } else {

                return true;

            }

        },
        hideHeader(): boolean {

            const hideHeaderQuery = this.$route.query.hideHeader;
            return typeof hideHeaderQuery === 'string' && hideHeaderQuery !== '';

        }

    },
    methods: {
        tabChange( status: boolean ) {

            if ( status  ) {

                this.currentTab = 'cloud';

            } else {

                this.currentTab = 'sim';

            }

        }
    }
});
</script>

<style lang="less" scoped>
main{
    padding-top: 69px;
    margin: 0 auto;
    @media @pc{
        max-width: 1000px;
    }
    @media @mobile{
        padding: 0 20px;
        padding-top: 22px;
        margin: 0;
    }
    & > h2{
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 32px;
        @media @mobile{
            font-size: 20px;
            text-align: center;
        }
    }
}
</style>
